"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Navigator = _interopRequireDefault(require("../App/Navigator.js"));
var _ReactUtils = _interopRequireDefault(require("../Utils/ReactUtils.js"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * An abstraction of Material UI's `IconButton`
 * 
 * Original author @heron-web/material (no longer maintained)
 */const IconButton = props => {
  /**
   * Clicked.
   * 
   * @return {void}
   */
  const handleClick = () => {
    const uri = props.uri;
    if (uri) _Navigator.default.navigate(uri);else props.onClick?.(props.value, props.name);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.default, {
    arrow: true,
    title: props.tooltip || "",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
        className: props.className,
        color: props.color,
        component: props.component,
        disabled: props.disabled,
        onClick: handleClick,
        size: props.size,
        style: props.style,
        type: props.type,
        tabIndex: props.tabIndex,
        children: _ReactUtils.default.render(props.icon)
      })
    })
  });
};
IconButton.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.oneOf(["inherit", "primary", "secondary", "success", "error", "info", "warning"]),
  component: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  icon: _propTypes.default.elementType,
  name: _propTypes.default.string,
  onClick: _propTypes.default.func,
  size: _propTypes.default.oneOf(["small", "medium"]),
  style: _propTypes.default.object,
  tabIndex: _propTypes.default.string,
  type: _propTypes.default.string,
  tooltip: _propTypes.default.string,
  uri: _propTypes.default.string,
  value: _propTypes.default.any
};
IconButton.defaultProps = {
  color: "primary",
  size: "medium"
};
var _default = exports.default = IconButton;